import { render, staticRenderFns } from "./DetectionDetail.vue?vue&type=template&id=0c3fb845&scoped=true"
import script from "./DetectionDetail.vue?vue&type=script&lang=js"
export * from "./DetectionDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c3fb845",
  null
  
)

export default component.exports